export function versions() {
  const ua = navigator.userAgent
  
  return {
    // 操作系统
    isWindows: /Windows/i.test(ua),
    isMac: /Macintosh/i.test(ua),
    isLinux: /Linux/i.test(ua),
    isIOS: /iPhone|iPad|iPod/i.test(ua),
    isAndroid: /Android/i.test(ua),
    isHarmony:/Harmony/i.test(ua),
  }
}